<template>
  <Popover placement="bottom" :width="350">
    <div title="Filter Resources" class="drop-down-button" v-bind:class="{'alpha' : filterAlpha}">
      <i class="fal fa-paperclip"></i>
    </div>
    <div slot="content">
      <div class="filter-tools-fixed">
        <div class="drop-down-filter-header">
          <h3 class="filter-header">Filter Resources</h3>
          <span class="filter-select-all-text" v-on:click="selectAll()">{{selectAllText}}</span>
          <div style="clear: both;"></div>
        </div>
        <Search v-on:searcher="onSearch" :placeholder="'Search resource types'"/>
      </div>
      <div class="filter-content">
        <div v-for="(resource, val) in searchedList" v-bind:key="val" class="list-item" @click="resourceTypes[resource].filteredIn = !resourceTypes[resource].filteredIn; resourceTypeFilterChanged(resource);">
          <div class="list-item-title"> <img :for="resource" :src="$config.get('basePathFiles') + utils.resourceTypeImg(resource)"> <span style="display: inline-block; vertical-align: top; margin: 4px 10px 0">{{resourceTypes[resource].name}}</span></div>
          <input class="filter-checkbox" type="checkbox" name="resource" :id="resource" @change="resourceTypeFilterChanged(resource)" v-model="resourceTypes[resource].filteredIn">
        </div>
      </div>
    </div>
  </Popover>
</template>

<script>
  const _ = require('lodash');
  import Vue from 'vue';
  
  import utils from '@/utils/utils.js';
  import Popover from '../popover'
  import Search from '../Search';
  
  export default {
    name: 'ResourceTypesFilter',
    components: {
      Popover,
      Search
    },
    data: function () {
      var t = this;

      return {
       utils: utils,
       error: '',
       search: '',
       selectAllText: 'Deselect all',
       filterAlpha: false
      }
    },
    props: [
      'resourceTypes', 'resourceTypeFiltersApplied', 'popupOptions'
    ],
    mounted: function () {
    },
    computed: {
      searchedList() {
        return Object.keys(this.resourceTypes).filter(resource => {
          return resource.toLowerCase().includes(this.search.toLowerCase())
        })
      }
    },    
    methods: {
      calculateFilterButtonText: function () {
        var t = this;

        var allFilteredIn = _.countBy(t.resourceTypes, 'filteredIn')['true'] === Object.keys(t.resourceTypes).length;

        this.filterAlpha = allFilteredIn ? false : true;
        return allFilteredIn ? "Deselect all" : "Reset filters";
      },
      onSearch: function(val) {
        this.search = val;
      },
      selectAll: function () {
        var t = this;

        if (t.selectAllText === "Deselect all") {
          _.each(t.resourceTypes, function(resourceType, key) {
            Vue.set(resourceType, 'filteredIn', false);
          });
        } else {
          _.each(t.resourceTypes, function(resourceType) {
            Vue.set(resourceType, 'filteredIn', true);
          });
        }

        t.selectAllText = t.calculateFilterButtonText();
        t.resourceTypeFiltersApplied();
      },
      resourceTypeFilterChanged: function(type) {
        this.selectAllText = this.calculateFilterButtonText();
        this.resourceTypeFiltersApplied();
      }
    }
  }
</script>

<style scoped>

.list-item-title {
  width: calc(100% - 55px);
}

.filter-content {
  height: 45vh;
}

.filter-content img {
  height: 32px !important;
}

.alpha {
  color: rgba(0, 0, 0, 0.3);
}

/* @media only screen and (max-width: 600px) {
  .filter-tools-fixed {
    max-width: 290px;
  }

  .list-item-title {
    width: 150px;
  }

  .list-item label {
    width: 230px;
  }
} */

</style>